module.exports = __webpack_public_path__ + "static/media/minceraftLogo.efc3a0f6.png";